export default {
  // 数据过滤方法
  filterShowList(list, lable, pageNum){
    let showList = list,
      filterCount = 0,
      filterList = showList.filter(function(item){
        if (lable == 'Setting' && (item.dataName == 'tp_LocationEnable' || item.dataName == 'tp_LocationInterval')) {
          filterCount++;
          return false;
        }else{
          return item.viewName === lable;
        }
      });

    let pageSize = 100,
      begin = (pageNum-1) * pageSize,
      end = pageNum * pageSize,
      length = filterList.length;

    if(end > length)
      end = length;

    // 设置最大页数、 裁取显示集合
    if((length % pageSize) != 0){
      return {
        pageCount : Math.floor(length/pageSize) + 1,
        showList : filterList.slice(begin,end),
        filterCount: filterCount
      }
    }else{
      return {
        pageCount : length/pageSize,
        showList : filterList.slice(begin,end),
        filterCount: filterCount
      }
    }
  },

  isBank(obj){
    if (obj == null)
      return true;
    else if (obj == '')
      return true;
    else
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/yyUtils.js